import { render, staticRenderFns } from "./PupilsGridSelect.vue?vue&type=template&id=05bff0e4&"
import script from "./PupilsGridSelect.vue?vue&type=script&lang=js&"
export * from "./PupilsGridSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports